import {useEffect, useState} from "react";
import {getAllBatches} from "../../api/Api";
import {AutoComplete, Card, Row, Col} from "antd";
import {toFSDateTime} from "../../util/timeutils";

export const BatchSelectWidget = ({selectedBatch, onSelect, disabled=false, refresh, onApiFail, displayType="card", defaultActive=true, props}) => {
    const [batches, setBatches] = useState([]);
    const [options, setOptions] = useState([]);

    const [select, setSelect] = useState(defaultActive);
    const [value, setValue] = useState(undefined);

    useEffect(() => {
        getAllBatches().then(data => {
            const b = data.map(val => {
                return {
                    key: val.id,
                    ...val,
                }
            })
            setBatches(b);
        }).catch(e => {
            if (e.status === 401) {
                if (onApiFail) {
                    onApiFail();
                }
            }
        });
    }, [onApiFail, refresh]);

    const onChange = (data) => {
        setValue(data);
    }

    const onSearch = (text) => {
        const newOptions = batches.filter(batch => {
            const ltext = text.toLowerCase();
            return batch.name.toLowerCase().includes(ltext);
        }).map(val => {
            return {
                value: `${val.name}`,
                batch: val,
                key: val.key
            }
        });
        setOptions(newOptions)
    }

    const selectBatch = (val, option) => {
        if (onSelect) {
            onSelect(option.batch);
        }
        setSelect(false);
    }

    const autoCompleteStyle = {
        width: 200
    }

    const clickBatch = () => {
        setSelect(true && !disabled);
    }

    const title = <b>Batch</b>
    const cardStyle = {
        textAlign: 'left'
    }

    const autoCompContent = <AutoComplete options={options} style={autoCompleteStyle} value={value} placeholder={'Batch'} onChange={onChange} onSearch={onSearch} onSelect={selectBatch} />
    const autoCompCard = <Card title={title} style={cardStyle}>
        {autoCompContent}
    </Card>

    const autocomp = (displayType === 'card') ? autoCompCard : autoCompContent;

    if ((selectedBatch === undefined) || (selectedBatch === null)) {
        return autocomp;
    }

    const {created} = selectedBatch;

    const content = <div onClick={clickBatch}>
        <Row>{selectedBatch.name}</Row>
        {(selectedBatch.description) && <Row>{
            selectedBatch.description
        }
        </Row>}
        <Row>
            <Col span={3}>
                <b>Created:</b>
            </Col>
            <Col>
                {toFSDateTime(new Date(created))}
            </Col>
        </Row>
    </div>

    const card = <Card title={title} style={cardStyle}>
        {content}
    </Card>

    const result = (displayType === 'card') ? card : content;
    return (select) ? autocomp : result;
}